import { useInfiniteQuery } from "@tanstack/react-query";
import { getNextPageParam, getPreviousPageParam } from "../../../utils/api";
import {
  GET_PURCHASES_LIST_QUERY_KEY,
  getPurchasesList,
} from "../api/purchasesApi";
import { usePurchasesFilterState } from "./usePurchasesFilterState";
import { useUserData } from "../../../hooks/useUserData";

export function usePurchasesAPI() {
  const { filters, urlSettled } = usePurchasesFilterState();
  const { userData } = useUserData();

  const {
    isLoading,
    data,
    error,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useInfiniteQuery({
    enabled: urlSettled,
    queryFn: (ctx) => {
      const paginatedFilters = new URLSearchParams(filters);
      paginatedFilters.set("p", "" + ctx.pageParam);
      return getPurchasesList(paginatedFilters);
    },
    queryKey: [...GET_PURCHASES_LIST_QUERY_KEY, userData?.id],
    initialPageParam: 1,
    getNextPageParam,
    getPreviousPageParam,
    refetchOnWindowFocus: false,
  });

  return {
    urlSettled,
    isLoading,
    data,
    error,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    showEmptyState:
      !isLoading && (!data?.pages?.[0].data.payload.results.length || error),
  };
}
